import {css} from '@emotion/react'
import {Tooltip} from 'antd'
import {useMapContext} from '@/components/MindMap/index.mjs'

const cssNodePreview = css({
    width: 13,
    height: 13,
    fontSize: 13,
    fontWeight: 'bold',
    lineHeight: 1,
    textAlign: 'center',
    pointerEvents: 'auto',
})

const TitleA = (props) => {
    return <div {...props}>将被新增的节点</div>
}

const TitleD = (props) => {
    return <div {...props}>将被删除的节点</div>
}

const cssModifications = css({
    'table': {
        marginTop: 8,
    },

    'th, td': {
        border: '1px solid',
        padding: 4,
    },
})

const TitleM = ({node, ...props}) => {
    const map = useMapContext()
    const {bizNodeType} = node.data
    const model = new map.BizNode[bizNodeType].Model
    const trs = []

    for (const [p, v2] of Object.entries(node.data)) {
        const v1 = node.mode.data[p]

        if (v1 !== v2) {
            const name = model.name(node, p)

            trs.push(
                <tr key={p}>
                    <th>{name ?? p}</th>
                    <td>{v1} → {v2}</td>
                </tr>
            )
        }
    }

    return (
        <div
            css={cssModifications}
            {...props}
        >
            <div>将被修改的节点</div>

            <table>
                <tbody>
                    {trs}
                </tbody>
            </table>
        </div>
    )
}

export default function NodePreview({node, ...props}) {
    const map = useMapContext()
    map.useNodeChange(node, ['mode'])

    if ('preview' !== node.mode?.code) {
        return null
    }

    const children = {
        add: 'A',
        delete: 'D',
        modify: 'M',
    }[node.mode.type]

    const title = {
        add: <TitleA />,
        delete: <TitleD />,
        modify: <TitleM node={node} />,
    }[node.mode.type]

    return (
        <Tooltip
            css={cssNodePreview}
            placement="right"
            title={title}
            {...props}
        >
            {children}
        </Tooltip>
    )
}
